export default __webpack_public_path__ + "static/media/fifteen.39fb2768.png";